import { useState, useEffect } from 'react';

let CachedPhoneUtils: any;

export default () => {
  const [PhoneUtils, setPhoneUtils] = useState(CachedPhoneUtils);

  useEffect(() => {
    let isMounted = true;

    if (!PhoneUtils) {
      import('@wix/wixrest-utils/dist/PhoneUtils').then((lib) => {
        if (isMounted) {
          CachedPhoneUtils = lib.default;
          setPhoneUtils(CachedPhoneUtils);
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [PhoneUtils]);

  return PhoneUtils;
};
